// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zWhY","label":"styles_label__3_L91"};